import type { FC } from 'react';

import type { BlockLibraryListProps } from '../components';
import { BlocksLibraryList, SelectedItemsPanel } from '../components';

import type { BlocksCountProps } from './BlocksCount';
import { BlocksCount } from './BlocksCount';

interface BlockLibraryListSuccessProps extends BlockLibraryListProps, BlocksCountProps {
  isSelectionExpanded: boolean;
  onToggleSelectionExpanded: () => void;
  onClearSelection: () => void;
  onRemoveFromSelection: (blockId: string) => void;
  onInsertAll: () => void;
}

export const BlockLibraryListSuccess: FC<BlockLibraryListSuccessProps> = ({
  count,
  total,
  isSelectionExpanded,
  onToggleSelectionExpanded,
  onClearSelection,
  onRemoveFromSelection,
  onInsertAll,
  ...blockLibraryListProps
}) => {
  const selectedBlocks = blockLibraryListProps.selectedBlocks ?? new Map();

  return (
    <>
      <div className="text-info-700 flex flex-col text-xs!">
        <BlocksLibraryList {...blockLibraryListProps} total={total} className="col-span-4 h-full overflow-y-auto" />
        <SelectedItemsPanel
          selectedBlocks={selectedBlocks}
          isClause={blockLibraryListProps.isClause}
          isExpanded={isSelectionExpanded}
          onToggleExpanded={onToggleSelectionExpanded}
          onRemove={onRemoveFromSelection}
          onClearSelection={onClearSelection}
          onInsertAll={onInsertAll}
        />
      </div>
      <BlocksCount count={count} total={total} />
    </>
  );
};
